<script>
  import { events } from './stores.js';
  import { onDestroy } from 'svelte';

  let volume = 0.2;
  let sliderValue = 1000 * volume;
  let audio = new Audio("/dingding.m4a");
  audio.volume = volume;

  function ding() {
    audio.pause();
    audio.currentTime = 0;
    audio.play();
  }

  $: audio.volume = volume;
  $: volume = sliderValue / 1000;

  const unsubscribe = events.subscribe((event) => {
    if(event.name === "taskComplete") {
      ding();
    }
  })

  onDestroy(unsubscribe);
</script>

<div class="box sound">
  <h2>Sound</h2>
  <input type="range" min="0" max="1000" step="1" bind:value={sliderValue} />
  <img class="action corner-button" src="/sound.png" on:click={ding} alt="Ding" title="Test sound" />
</div>

<style>
  input {
    width: 100%;
  }
</style>